module.exports = __webpack_public_path__ + "static/media/game-bossright.ec58606b.png";